export default {
  setDirectMessages(state, directMessages) {
    state.directMessages = directMessages
  },
  deleteDirectMessage(state, directMessageId) {
    state.directMessages = state.directMessages.filter(((dm) => dm.id !== directMessageId))
  },
}
